// extracted by mini-css-extract-plugin
export var base = "Badge-module--base--d731f";
export var caution = "Badge-module--caution--30727";
export var dot = "Badge-module--dot--b9cf4";
export var l = "Badge-module--l--65734";
export var lighted = "Badge-module--lighted--d8a97";
export var m = "Badge-module--m--6a988";
export var primary = "Badge-module--primary--bee63";
export var s = "Badge-module--s--8c259";
export var solid = "Badge-module--solid--3fe1c";
export var transparent = "Badge-module--transparent--39119";
export var xl = "Badge-module--xl--b3ae8";